module.exports = "<div [innerHtml]=\"myTemplate\"></div>"